import React from "react";

const SideMenuContext = React.createContext({});
SideMenuContext.displayName = "SideMenuContext";

export default SideMenuContext;
